// extracted by mini-css-extract-plugin
export default {"dialogContainer":"_customer-number-reservation-dialog_dialogContainer__2S31z","inputField":"_customer-number-reservation-dialog_inputField__o9vOo"};